<template>
  <div class="strip-img" ref="image">
    <img :src="src" :alt="name">
  </div>
</template>

<script>
export default {
  name: 'StripImg',
  props: {
    name: String,
    url: String,
    urlMobile: String,
  },
  computed: {
    src() {
      return window.innerWidth <= 600 ? this.urlMobile : this.url;
    },
  },
  mounted() {
    this.$refs.image.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    }, false);
  },
};
</script>

<style lang="scss" scoped>
.strip-img {
  min-height: 50vh;
  @media all and (max-width: 800px) {
    min-height: 100vh;
  }
  img {
    display: block;
    width: 100%;
    pointer-events: none;
  }
}
</style>
